import React, { useState, useRef, useImperativeHandle, forwardRef } from 'react';
import classNames from 'classnames';

import { isWrapped, unwrap } from '../../../../utils/ChangeSpy';

import style from './style.module.css';

const TextEditor = forwardRef((props, ref) => {
  const [value, setValue] = useState(unwrap(props.value));
  const [error, setError] = useState(false);
  const editorRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getValue: () => {
      if (error) {
        return props.value;
      }

      if (isWrapped(props.value)) {
        return Object.assign({}, props.value, { value });
      }

      return value;
    },
    isPopup: () => false,
    afterGuiAttached: () => {
      if (editorRef.current) {
        editorRef.current.select();
      }
    },
  }));

  const handleChange = ({ target: { value: newValue } }) => {
    setValue(newValue);
    setError(!props.column.colDef.isValid(newValue));
  };

  const { handleBlur } = props.column.colDef;
  const inputClassName = classNames(style.input, 'form-control input-sm');

  return (
    <span className="control-wrap">
      <input
        ref={editorRef}
        className={inputClassName}
        onBlur={handleBlur}
        onChange={handleChange}
        placeholder={props.column.placeHolder}
        type="text"
        value={value}
      />
    </span>
  );
});

export default TextEditor;
